// removed by extract-text-webpack-plugin
module.exports = {"container-loader":"ContainerLoader__container-loader","containerLoader":"ContainerLoader__container-loader","spinner-grad-wrap":"ContainerLoader__spinner-grad-wrap","spinnerGradWrap":"ContainerLoader__spinner-grad-wrap","spinner-spinner-grad":"ContainerLoader__spinner-spinner-grad","spinnerSpinnerGrad":"ContainerLoader__spinner-spinner-grad","spin":"ContainerLoader__spin"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/atoms/ContainerLoader/ContainerLoader.css
// module id = 1124
// module chunks = 8